import React from "react";
import { classNames } from "../../utils/classNames";
export const HeaderPanelWrapper = ({ children }) => {
    return React.createElement("div", null, children);
};
export const HeaderPanels = ({ children, className, }) => (React.createElement("div", { className: classNames("header--panels", className ?? "") }, children));
